export const isSsrDisabled = () => process.env.REACT_APP_SSR_MODE === 'false';
